import { envService } from '../services/envService';

export const requestOptions = {
  baseURL: envService.getApiUrl,
};
